<!-- <dashboardnav> -->

  <cradua-pipelinegrade
  [pipelinegrades]="pipelinegrades$ | async"
  (pipelinegrade)="onSubmitPipelinegrade($event)"
  (deletePipelineGradeEvent)="onDeletePipelinegrade($event)"
  *ngIf="(isLoadingPipelinegrade$ | async ) === false"
  >
</cradua-pipelinegrade>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingPipelinegrade$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
<!-- </dashboardnav> -->
